<template>
  <div class="footer">
    <div class="product-selection">
      <h2>产品选购</h2>
      <ul>
        <li>P系列</li>
        <li>U系列</li>
        <li>K系列</li>
        <li>E系列</li>
        <li>C系列</li>
        <li>更多...</li>
      </ul>
    </div>
    <div class="explore">
      <h2>探索谱褀</h2>
      <ul>
        <li>品牌定位</li>
        <li>研发设计</li>
        <li>绿色智造</li>
        <li>展示中心</li>
      </ul>
    </div>
    <div class="user-service">
      <h2>用户服务</h2>
      <ul>
        <li>售后服务</li>
        <li>联系我们</li>
        <li>常见问题</li>
      </ul>
    </div>
    <div class="follow">
      <h2>关注谱褀</h2>
      <ul>
        <li>微信</li>
        <li>小红书</li>
        <li>Facebook</li>
        <li>京东</li>
      </ul>
    </div>
    <div class="company-info">
      <p>广州谱褀商业发展有限公司</p>
      <p>E-mail: coop@puki.vip</p>
      <p>© 2024 PUKI 保留所有权利</p>
      <p>备案号</p>
      <p>经营执照</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style scoped>
.footer {
  background-color: black;
  color: white;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding: 20px;
}

.footer h2 {
  font-size: 16px;
  margin-bottom: 10px;
}

.footer ul {
  list-style: none;
  padding: 0;
}

.footer li {
  margin: 5px 0;
}

.company-info {
  margin-top: 20px;
  text-align: center;
}
</style>
